module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-app": ""
    }
  }, [(_vm.clientId === 'digiteka') ? _c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "/static/css/digiteka.css",
      "type": "text/css",
      "media": "all"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "container",
    attrs: {
      "flat": "",
      "id": "top-bar"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "logo-wrap"
  }, [(_vm.$store.state.consumerLogo) ? _c('img', {
    attrs: {
      "src": _vm.$store.state.consumerLogo,
      "alt": "logo"
    }
  }) : _c('img', {
    attrs: {
      "src": require("./assets/img/logo.png"),
      "alt": "logo"
    }
  })]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', {
    staticClass: "top-menu"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/videos/new',
        exact: true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.videos')))]), _vm._v(" "), (_vm.$store.state.consumerGroup == 'ebra') ? _c('router-link', {
    attrs: {
      "to": {
        path: '/images/new',
        exact: true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.images')))]) : _vm._e(), _vm._v(" "), (_vm.$store.state.is_manager) ? [_c('router-link', {
    attrs: {
      "to": {
        path: '/user',
        exact: true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.users')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/settings',
        exact: true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.settings')))])] : _vm._e(), _vm._v(" "), (_vm.$store.state.authenticated) ? [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.logout($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('logout')))])] : [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.logout($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('login')))])], _vm._v(" "), _c('div', {
    staticClass: "dropdown locale-menu"
  }, [_c('a', {
    staticClass: "clickable dropdown-toggle",
    on: {
      "click": function($event) {
        _vm.dropdownToggle = !_vm.dropdownToggle
      }
    }
  }, [_vm._v(_vm._s(_vm.currentLocale) + " "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    class: {
      'show': _vm.dropdownToggle
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.updateLocale('en')
      }
    }
  }, [_vm._v("en")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.updateLocale('fr')
      }
    }
  }, [_vm._v("fr")])])])])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('service-message'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('error-display', {
    staticClass: "error-display"
  }), _vm._v(" "), (_vm.updateAvailable) ? _c('update-prompt') : _vm._e(), _vm._v(" "), _c('modal-record-player'), _vm._v(" "), _c('snack-bar')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2790ecfe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1027
// module chunks = 1